import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-dots',
  template: `
    <div class="flex gap-1 pl-1 pt-1" data-testid="loading-dots">
      <div class="dot h-1 w-1 rounded-full bg-black opacity-20"></div>
      <div class="dot h-1 w-1 rounded-full bg-black opacity-20"></div>
      <div class="dot h-1 w-1 rounded-full bg-black opacity-20"></div>
    </div>
  `,
  styles: [
    `
      .dot {
        animation: pulse 1.5s infinite;
      }

      @keyframes pulse {
        0%,
        100% {
          opacity: 0;
        }
        50% {
          opacity: 1;
        }
      }

      .dot:nth-child(1) {
        animation-delay: 0s;
      }
      .dot:nth-child(2) {
        animation-delay: 0.1s;
      }
      .dot:nth-child(3) {
        animation-delay: 0.2s;
      }
    `,
  ],
  standalone: true,
})
export class LoadingDotsComponent {}
